export default class formConfig {
  // 银行基本户-详情
  static configList() {
    return [
      {
        title: "基本信息",
        name: "1",
        icon: "",
        tipsList: [
          { text: "问：为什么每个项目负责人须创建一个单独的账号？" },
          { text: "答：（1）项目负责人可自行完善本人的注册信息。" },
          { type: "slot", slotName: "tipsList1" },
          { type: "slot", slotName: "tipsList2" },
        ],
        formConfigList: [
          {
            label: "登录名：",
            type: "slot",
            value: "loginName",
            slotName: "loginName",
            tip: "该登录名为项目负责人的登录用户名，登录名请输入字母、数字及“-”“_”的组合!",
            maxlength: 100,
            required: true,
            rule: {
              required: true,
              message: "请填写登录名",
              trigger: "blur"
            }
          },
          {
            label: "姓名：",
            type: "input",
            value: "personName",
            maxlength: 15,
            required: true,
            rule: {
              required: true,
              message: "请填写姓名",
              trigger: "blur"
            }
          },
          {
            label: "性别：",
            type: "select",
            value: "sexNum",
            placeholder: "请输入",
            queryParams: {
              url: "/dataDictionaryEntries/BasicDataCombobox",
              zdid: "201507071441150002"
            },
            rule: {
              required: true,
              message: "请选择性别",
              trigger: "blur"
            }
          },
          {
            label: "电子邮箱：",
            type: "input",
            value: "lxrdzyx",
            tip: "该电子邮箱主要用于注册时接收密码邮件和进行密码找回!",
            maxlength: 150,
            required: true,
            rule: {
              required: true,
              message: "请填写电子邮箱",
              trigger: "blur"
            }
          },
          {
            label: "证件类型：",
            type: "select",
            value: "idCardTypeNum",
            placeholder: "请输入",
            queryParams: {
              url: "/dataDictionaryEntries/BasicDataCombobox",
              zdid: "201507052149470004"
            },
            rule: {
              required: true,
              message: "请选择证件类型",
              trigger: "blur"
            }
          },
          {
            label: "证件号码：",
            type: "input",
            value: "idCard",
            maxlength: 30,
            required: true,
            rule: {
              required: true,
              message: "请填写证件号码",
              trigger: "blur"
            }
          },
          {
            label: "出生日期：",
            type: "date",
            value: "birthDay",
            dateType: "date",
            required: true,
            clearable: true,
            valueFormat: "yyyy-MM-dd",
            rule: {
              required: true,
              message: "请选择出生日期",
              trigger: "change"
            }
          },
          {
            label: "学历：",
            type: "select",
            value: "eduLevelNum",
            placeholder: "请输入",
            queryParams: {
              url: "/dataDictionaryEntries/BasicDataCombobox",
              zdid: "201312111631590005"
            }
          },
          {
            label: "手机号码：",
            type: "input",
            value: "mobile",
            maxlength: 11,
            required: true,
            rule: {
              required: true,
              message: "请填写手机号码",
              trigger: "blur"
            }
          },
          {
            label: "邮政编码：",
            type: "input",
            value: "zipCode",
            maxlength: 30,
            required: true
          },
          {
            label: "所在省：",
            type: "select",
            value: "provinceNum",
            placeholder: "请输入",
            queryParams: {
              url: "/administrativeArea/administrativeAreaCombobox",
              zdid: "201507041523100004"
            }
          },
          {
            label: "所在市：",
            type: "select",
            value: "regionCode",
            placeholder: "请输入",
            queryParams: {}
          },
          {
            label: "是否在职：",
            type: "select",
            value: "onJob",
            placeholder: "请输入",
            width: "100%",
            required: true,
            queryParams: {
              url: "/dataDictionaryEntries/BasicDataCombobox",
              zdid: "201610190958144723"
            },
            rule: {
              required: true,
              message: "请选择是否在职",
              trigger: "change"
            }
          },
          {
            label: "职务：",
            type: "input",
            value: "job",
            maxlength: 50,
            required: true
          },
          {
            label: "技术职称：",
            type: "input",
            value: "techTitle",
            maxlength: 50,
            required: true
          },
          {
            label: "从业年限：",
            type: "input",
            value: "workingYear",
            tip: "（请填写数字）",
            maxlength: 50,
            required: true,
            placeholder: "请输入数字",
            rule: {
              pattern: /^([1-9]\d*|0)(\.\d{1,6})?$$/,
              message: "请输入数字"
            }
          },
          {
            label: "社会保险缴纳情况：",
            type: "input",
            value: "socialInsurancePayment",
            maxlength: 300,
            required: true
          },
          {
            label: "从业经历：",
            type: "textarea",
            value: "workingExperience",
            maxlength: 1200,
            minRows: "3",
            maxRows: "2",
            width: "100%",
            rule: {
              required: true,
              message: "请填写从业经历",
              trigger: "blur"
            }
          },
        ]
      },
      {
        title: "备注",
        name: "2",
        icon: "",
        formConfigList: [
          {
            label: "备注：",
            value: "description",
            type: "textarea",
            class: "formTextarea",
            width: "100%",
            required: true,
            maxlength: 1200,
            minRows: "3",
            maxRows: "2"
          }
        ]
      },
      {
        title: "建造师安全生产考核证",
        name: "3",
        icon: "",
        formConfigList: [
          {
            label: "证书编号：",
            type: "input",
            value: "certificateNumber",
            maxlength: 50,
            required: true
          },
          {
            label: "发证单位：",
            type: "input",
            value: "certificationUnit",
            maxlength: 30,
            required: true
          },
          {
            label: "发证日期：",
            type: "date",
            value: "certificationDate",
            dateType: "date",
            valueFormat: "yyyy-MM-dd",
            rule: { required: false, message: "发证日期", trigger: "change" }
          },
          {
            label: "证书有效期截止日期：",
            type: "date",
            value: "certificationEndDate",
            dateType: "date",
            valueFormat: "yyyy-MM-dd",
            rule: {
              required: false,
              message: "证书有效期截止日期",
              trigger: "change"
            }
          }
        ]
      },
      {
        title: "证书信息",
        name: "4",
        icon: "",
        tipsList: [
          { text: "项目负责人在对货物类项目进行投标时，若公告对项目负责人无注册信息要求，则无须填写注册证书信息，若有要求，则根据项目负责人实际情况填写。" },
          { text: "填写完基本信息并保存后，在完善证书信息（证书资格信息、证书资格证书扫描件）！" }
        ],
        formConfigList: [
          {
            label: "证书信息：",
            type: "slot",
            slotName: "caLook",
            width: "100%;"
          }
        ]
      },
      {
        title: "其他",
        name: "5",
        icon: "",
        tipsList: [
          { text: "填写完基本信息并保存后，请上传相关项目负责人身份证明扫描件（只能上传身份证扫描件或其他身份证明扫描件）！" },
          { text: "已“通过”的项目负责人信息记录，如再次提交，须重新进行信息核验，请谨慎操作！" },
          { text: "（1）若该项目负责人已经办理CA锁，则项目负责人的身份证信息则不可修改，如身份证信息填写错误需修改，则须联系交易平台客服。" },
          { text: "（2）若非上述情况，该项目负责人身份证基本信息可修改。" },
        ],
        formConfigList: [
          {
            label: "上传彩色扫描件：",
            type: "slot",
            slotName: "uploadFile"
          },
          // {
          //   label: "核验记录：",
          //   type: "slot",
          //   slotName: "auditStateName",
          //   value: "auditStateName",
          //   disabled: true,
          //   required: true
          // },
        ]
      },
      {
        title: "免责声明",
        name: "6",
        icon: "",
        formConfigList: [
          {
            label: "",
            type: "slot",
            slotName: "statement",
            width: "100%",
            class: "noMargin"
          }
        ]
      }
    ];
  }
}
